import StudyCreationFlow from "@/features/studies/creation/StudyCreationFlow";

export function CreateStudyRoute() {
  return <StudyCreationFlow />;
}

export default CreateStudyRoute;
